import { createStore } from 'vuex';
import commonModule from './modules/common';
import authModule from './modules/auth';
import contactModule from './modules/contact';
import shopModule from './modules/shop';
import eventModule from './modules/event';
import chargeModule from './modules/charge';
import customerModule from './modules/customer';
import newsModule from './modules/news';
import historyModule from './modules/history';
import mimamoriModule from './modules/mimamori';
import pointModule from './modules/point';
import couponModule from './modules/coupon';
import ticketModule from './modules/ticket';

export const store = createStore({
  modules: {
    common: commonModule,
    auth: authModule,
    customer: customerModule,
    contact: contactModule,
    shop: shopModule,
    history: historyModule,
    event: eventModule,
    charge: chargeModule,
    news: newsModule,
    mimamori: mimamoriModule,
    point: pointModule,
    coupon: couponModule,
    ticket: ticketModule,
  },
});
